import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f154c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid premium-section" }
const _hoisted_2 = { class: "row w-100" }
const _hoisted_3 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_4 = { class: "premium-content text-left" }

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Nostros',
  props: {
    backGround: String,
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col-md-6 premium-image",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/img/' + __props.backGround) + ')' })
      }, null, 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})